import React, { FC } from 'react'

import { RevenueModel } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { revenueModelLabel } from '@new/__global/constants/revenueModel'

import { FiltersSharedProps } from './Filters.types'

interface RevenueModelFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const RevenueModelFilter: FC<RevenueModelFilterProps> = props => {
  const disabledOptions = [RevenueModel.undefined]

  const revenueModelOptions = Object.values(RevenueModel)
    .filter(revenueModel => !disabledOptions.includes(revenueModel))
    .map(revenueModel => ({
      value: revenueModel,
      hasFullWidth: true,
      label: revenueModelLabel[revenueModel],
    }))

  return <CheckboxBasedFilter title="Rev. Model" options={revenueModelOptions} {...props} />
}
